export enum RegimeType {
    Normal = 1,
    ImportExport = 2,
    Exempted = 3,
    EEC = 4,
    Cocontractant = 5,
    VATIncluded = 6,
}